import "../styles/story.css";
// import storyImage from '../../images/tubbees_slush_logo.webp'

export default function Twentysix() {
  return (
    <div className="containerStory">
      <div className="storyHeading">
        <h2>2026</h2>
        {/* <img src={storyImage} alt="Tubbees goes further" /> */}
      </div>

      <p>
        We took Tubbees beyond our own stores through Tubbees Express and a
        new UK distribution partnership with VSL Trade.
        <br />
        <span>
          Our first fully branded machines reached partner locations, complete
          with Tubbees syrups, cups, straws and point-of-sale branding.
        </span>
      </p>

      <p>
        We kept creating too, launching Spaghetti Crepes, Dirty Sodas,
        Flurry Trays and exclusive new slushee flavours including Berry
        Cherry Limeade and American Root Beer.
      </p>
    </div>
  );
}